export default __webpack_public_path__ + "static/media/Setting_User.2449ffe6.svg";